import React from 'react'
import Button, { NoBackgroundButton } from 'components/Button'
import commonStyles from 'styles/globalStyles'

type Props = {
  nextText?: string
  onPressBack?: () => void
  onPressNext: any
}

const StepButtons = (props: Props) => {
  return (
    <div style={styles.container}>
      <div style={styles.rightContainer}>
        {!!props.onPressBack && (
          <NoBackgroundButton
            title='Voltar'
            onClick={props.onPressBack || (() => {})}
            style={{
              ...commonStyles.announcementSteps.button,
              marginRight: 16,
              marginLeft: 'auto',
            }}
          />
        )}

        <Button
          title={props.nextText || 'SALVAR'}
          onClick={props.onPressNext}
          style={commonStyles.announcementSteps.button}
        />
      </div>
    </div>
  )
}

const styles = {
  container: {
    width: '100%',
    marginTop: 20,
  },
  rightContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    maxWidth: 200,
    justifyContent: 'flex-end',
  },
}

export default StepButtons
